import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AssistitiApi, EntiApi, OperatoriApi, PuntiDiRaccoltaApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function usePuntiDiRaccoltaDataSource() {
    const api = new PuntiDiRaccoltaApi(apiConfiguration);
    const { currentTenant } = useContext(TenantContext);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            return api.getPuntiDiRaccolta({ tenantId: currentTenant.Id });
          },
    
          byKey: (key) => {
            return api.getPuntoDiRaccoltaByIdRaw({
                tenantId: currentTenant.Id,
                puntoDiRaccoltaId: key
            });
          },
    
          insert: (values) => {
            return api.insertPuntoDiRaccolta({
                tenantId: currentTenant.Id,
                puntoDiRaccoltaCreateDTO: values
            });
          },
    
          update: (key, values) => {
            return api.updatePuntoDiRaccolta({
                tenantId: currentTenant.Id,
                puntoDiRaccoltaId: key,
                puntoDiRaccoltaUpdateDTO: values  
            });
          },
    
          remove: (key) => {
            return api.deletePuntoDiRaccolta({
                tenantId: currentTenant.Id,
                puntoDiRaccoltaId: key    
            });
          }
        });
      }, [currentTenant]);
    
      return dataSource;
}


